import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';

/**
 * Sticky bottom CTA that appears right after the first hero CTA
 * scrolls out of view.
 */
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(entry.boundingClientRect.top < 0 && !entry.isIntersecting);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-31" data-mp="2aus2yihfbdwk">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 320,
      damping: 30
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-navy-100 bg-white/95 px-3 py-3 backdrop-blur-md shadow-[0_-8px_30px_rgba(11,42,91,0.15)]" data-id="element-32" data-mp="38ayuwcqsg3fk">
          <div className="mx-auto flex max-w-3xl flex-col items-center gap-1" data-id="element-33" data-mp="335ne5e372uyu">
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="flex w-full items-center justify-center gap-2 rounded-xl bg-accent px-4 py-3.5 text-[13px] font-extrabold uppercase tracking-wide text-white shadow-lg shadow-accent/30 transition-colors hover:bg-accent-dark active:scale-[0.98] sm:text-base" data-id="element-34" data-mp="2pbmnl7mece9k">
              Quiero la Ruta por USD $15
              <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-35" data-mp="2bcd6m5qd9g4j" />
            </a>
            <p className="text-[10px] font-medium text-navy-700/70 sm:text-xs" data-id="element-36" data-mp="4lxap05972ji">
              Acceso inmediato · Pago único · Garantía de 7 días
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}